import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/**
 * @typedef {Object} AffectedBundlesState
 * @property {number} count - Number of affected bundles
 *
 * @typedef {import('../slice.types').BaseSlice & AffectedBundlesState} AffectedBundlesSlice
 */

/** @type {AffectedBundlesSlice} */
export const initialAffectedBundlesState = {
  status: 'init',
  errors: [],
  count: 0
}

/** @enum {string} */
export const AFFECTED_BUNDLES_ACTIONS = {
  SET_AFFECTED_BUNDLES_STATUS: 'SET_AFFECTED_BUNDLES_STATUS',
  SET_AFFECTED_BUNDLES_ERRORS: 'SET_AFFECTED_BUNDLES_ERRORS',
  SET_AFFECTED_BUNDLES: 'SET_AFFECTED_BUNDLES'
}

export const affectedBundlesSlicePropTypes = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  count: PropTypes.number,
  affectedBundles: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string }))
})

/**
 * @typedef {{ type: AFFECTED_BUNDLES_ACTIONS, payload: AffectedBundlesSlice['status'] }} AffectedBundlesStatusAction
 * @typedef {{ type: AFFECTED_BUNDLES_ACTIONS, payload: AffectedBundlesSlice['errors'] }} AffectedBundlesErrorsAction
 * @typedef {{ type: AFFECTED_BUNDLES_ACTIONS, payload: AffectedBundlesSlice }} AffectedBundlesAction
 */
